import { useCallback, useState } from "react";
import { openSnapFrameExtractionTest } from "../plugins/NativeFilterLab";
import "./SnapFrameExtractionTestButton.css";

export default function SnapFrameExtractionTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenTest = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openSnapFrameExtractionTest();
      console.log("[snapFrameExtractionTest] result", result);
    } catch (error) {
      console.log("[snapFrameExtractionTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="snap-frame-extraction-test-btn"
      onClick={handleOpenTest}
      disabled={busy}
      aria-label="Open Snap Frame Extraction Test"
    >
      Open Snap Frame Extraction Test
    </button>
  );
}
